import { ref } from 'vue';

/**
 * 数据拼装处理插件
 * 负责管理最终渲染的列表数据，提供统一的 setData 接口
 */
export const createDataMerge = () => {
	return {
		name: 'dataMerge',

		install(paginationApi) {
			const { pluginContext, changePageTotal, currentPage, debugLog } = paginationApi;

			// 最终渲染的列表数据
			const finalData = ref([]);

			// 重置数据方法
			const resetFinalData = (newData = []) => {
				finalData.value = [...newData];
				debugLog('Data Merge Plugin', '重置数据，条数:', finalData.value.length);
			};

			// 追加数据方法
			const appendFinalData = (newData = []) => {
				finalData.value = [...finalData.value, ...newData];
				debugLog(
					'Data Merge Plugin',
					`追加数据，新增: ${newData.length} 条，总计: ${finalData.value.length} 条`
				);
			};

			/**
			 * 统一的数据设置接口（智能判断重置还是追加）
			 * @param {Array} newData - 新的数据数组
			 * @param {number} total - 数据总数
			 */
			const setData = (newData = [], total = 0) => {
				// 更新总数
				changePageTotal(total);

				// 根据当前页码智能判断是重置还是追加
				if (currentPage.value === 1) {
					resetFinalData(newData);
				} else {
					appendFinalData(newData);
				}
			};

			// 扩展插件上下文（使用命名空间）
			pluginContext.dataMerge = {
				finalData,
				resetFinalData,
				appendFinalData,
				setData
			};
		},

		beforeChange(context) {
			context.debugLog('Data Merge Plugin', '准备处理数据变化:', context.type);

			if (context.type === 'refresh') {
				// 避免刷新了页码，但因为旧的 total 不为 0，导致数据被错误追加的问题
				// refreshPagination ——> refresh Total ——> runAsyncChange
				const { setData } = context.pluginContext.dataMerge;
				setData([], 0);
			}
		},

		afterChange(context) {
			const { type } = context;
			context.debugLog('Data Merge Plugin', '数据变化完成:', type);
		}
	};
};
